import { bankTypes } from '../types/bankActionTypes'

const initialState = {
  banks: [],
  getMyBanks: [],

  deleteBankLoading: false,
  deleteBankSuccess: {},
  deleteBankErr: '',

  bankSettingsSuccess: {},
  verifyBankAccountSuccess: {},
}

export const bankReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case bankTypes.GET_ALL_BANKS_SUCCESS:
      return {
        ...state,
        banks: action.payload,
      }

    case bankTypes.GET_MY_BANKS_SUCCESS:
      return {
        ...state,
        getMyBanks: action.payload,
      }

    case bankTypes.BANK_SETTINGS_SUCCESS:
      return {
        ...state,
        bankSettingsSuccess: action.payload,
      }

    case bankTypes.VERIFY_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        verifyBankAccountSuccess: action.payload,
      }

    default:
      return state
  }
}
